import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  SeatData,
  SelectLocation,
  LocationFilterAction,
  SeatMappingName,
  CheckLoader,
} from '../../Redux/action/seatAction';
import { dataUser, logoutHandler } from '../Helpers/util';
import axios from 'axios';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import SwIconButton from '../Common/SwIconButton/SwIconButton';
import SwOffCanvas from '../Common/SwOffCanvas/SwOffCanvas';
import SwButton from '../Common/SwButtons/SwButtons';


const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

const options = [];
const options1 = [];
var optionsNew = [];

class FilterSeat extends Component {
  constructor(props) {
    super(props);

    this.state = {
      refreshSeat: null,
      refreshemp: null,
      status: '',
      locationData: [],
      setErrayData: [],
      company_id: UserObj.company_id,
      row: this.props.frow,
      pgno: this.props.page,
      seatno: '',
      seattype: '',
      empname: '',
      empid: '',
      location: '',
      itemsList: [],
      listNameNew: [],
      listName: [],
      showFilterOffCanvas: false,
    };
  }

  handleOpenFilter = () => {
    this.setState({ showFilterOffCanvas: true });
  };

  handleCloseFilter = () => {
    this.setState({ showFilterOffCanvas: false });
  };
  onKeyDown = e => {
    const formData = new FormData();
    if (e.target.value.length == 3) {
      this.apihit(e.target.value);
    }
  };

  handleChangeSet(e) {
    this.setState({
      empname: e.label,
    });
  }

  apihit(val) {
    let parm = {
      company_id: this.state.company_id,
      name: val,

    };
    if (!UserObj?.company_id) {
      logoutHandler()
    }
    this.props.SeatMappingName(parm);
  }

  handleChange = seatno => {
    // this.setState({ seatno: seatno.label, refreshSeat: seatno });
    this.setState({ seatno: seatno.label, refreshSeat: seatno }, () => {
      let parms = {
        company_id: this.state.company_id,
        location_id: this.state.location,
        seat_type: this.state.seattype,
        seat_status: this.state.status,
      };
      if (!UserObj?.company_id) {
        logoutHandler()
      }

      this.props.SelectLocation(parms);
    });
  };
  handleChange1 = empname => {
    this.setState({ empname: empname.value, refreshemp: empname });
  };

  changeSelectset = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  changeSelect = e => {
    let parms = {
      company_id: this.state.company_id,
      location_id: e.target.value,
    };
    this.setState({
      [e.target.name]: e.target.value,
      location: e.target.value,
    });
    if (!UserObj?.company_id) {
      logoutHandler()
    }
    this.props.SelectLocation(parms);
  };

  submitFilter = e => {
    e.preventDefault();
    const params = {
      company_id: this.state.company_id,
      status: this.state.status,
      row: this.props.frow,
      pgno: this.props.page,
      seatno: this.state.seatno,
      seattype: this.state.seattype,
      empid: this.state.empname,
      location: this.state.location,
    };

    this.props.CheckLoader();
    if (!UserObj?.company_id) {
      logoutHandler()
    }
    this.props.SeatData(params, 'action');

    this.handleCloseFilter();
    this.props.onSelectLanguage(params);
  };
  reload = e => {
    const params = {
      pgno: this.state.pgno,
      row: this.state.row,
      company_id: this.state.company_id,
    };
    if (!UserObj?.company_id) {
      logoutHandler()
    }
    this.props.SeatData(params);
    window.location.reload();

    this.setState({
      status: '',
      seatno: '',
      seattype: '',
      empname: '',
      empid: '',
      refreshSeat: '',
      refreshemp: '',
      location: '',
    });
  };

  componentWillReceiveProps(props) {
    if (props.seatName != '') {
      props.seatName &&
        this.setState({
          listName: props.seatName,
          listName2: props.seatName,
        });
    }
    if (props.seatReducer && props.seatReducer.status == 200) {
      this.setState({
        setErrayData: props.seatReducer && props.seatReducer.data,
      });
    }

    // if (props.LocationList && props.LocationList.status == 200) {
    //   this.setState({
    //     locationData:
    //       props.LocationList &&
    //       props.LocationList.data &&
    //       props.LocationList.data.data,
    //   });
    // }

    if (props.BuildingReducer && props.BuildingReducer.length != 0) {
      this.setState({
        buildingApiData: props.BuildingReducer,
        setFlagCity: true,
      });
    }
  }

  componentDidMount() {
    this.locationValue();
    this.setuserlist();
    let authToken = JSON.parse(localStorage.getItem('headData'))

    const params = {
      params: { spoc: UserObj.rec_id, client: UserObj.company_id },
      headers: {
        Authorization: authToken?.spintlyToken,
      }
    };
    axios
      .get(
        `${process.env.REACT_APP_API_URL}basic-data/get-location-by-spoc`,
        params,
      )
      .then(res => {
        if (res.data.status == 'success') {
          this.setState({
            locationData: res.data.data,
          });
        }
      });
  }
  setuserlist = () => {
    const params = {
      pgno: this.state.pgno,
      row: this.state.row,
      company_id: this.state.company_id,
    };
    if (!UserObj?.company_id) {
      logoutHandler()
    }
    this.props.SeatData(params);
  };

  /*1---setCity---*/
  locationValue = () => {
    var dataParam = {
      company_id: this.state.company_id,
      // token: 'U21hcnR3b3Jrcy1GZWVkYmFjay1BUEktVjEtMjAxOQ==',
    };
    if (!UserObj?.company_id) {
      logoutHandler()
    }
    this.props.LocationFilterAction(dataParam);
  };

  SeatTypemethod = seat => {
    this.setState({ seattype: seat.value }, () => {
      let parms = {
        company_id: this.state.company_id,
        location_id: this.state.location,
        seat_type: this.state.seattype,
      };

      this.props.SelectLocation(parms);
    });
  };

  SeatStatusmethod = status => {
    this.setState({ status: status.value }, () => {
      let parms = {
        company_id: this.state.company_id,
        location_id: this.state.location,
        seat_status: this.state.status,
        seat_type: this.state.seattype,
      };

      this.props.SelectLocation(parms);
    });
  };

  render() {
    const seatType = [];
    this.props.location.seatTypes &&
      this.props.location.seatTypes.map(seat => {
        if (seat.seat_type == 1) {
          seatType.push({ value: seat.seat_type, label: 'Fixed' });
        } else if (seat.seat_type == 2) {
          seatType.push({ value: seat.seat_type, label: 'Flexi' });
        }
      });

    const seatStatus = [];
    this.props.location.status &&
      this.props.location.status.map(seat => {
        if (seat.seat_status == 1) {
          seatStatus.push({
            value: seat.seat_status,
            label: 'Occupied',
          });
        } else if (seat.seat_status == 0) {
          seatStatus.push({ value: seat.seat_status, label: 'Vacant' });
        }
      });

    const empNames = [];
    this.props.location.empNames &&
      this.props.location.empNames.map(emp => {
        empNames.push({ value: emp.user_id, label: emp.name });
      });

    const seatNumbers = [];
    this.props.location.titles &&
      this.props.location.titles.map(seat => {
        seatNumbers.push({ value: seat.rec_id, label: seat.title });
      });

    if (this.state.setErrayData.list !== 0) {
      this.state.setErrayData.list &&
        this.state.setErrayData.list.map((items, i) => {
          if (items.ufname !== null || items.ulname !== null) {
            options1.push({
              value: items.ufname,
              label: items.ufname + ' ' + items.ulname,
            });
          }
        });
    }
    const locationOptions = [
      { value: "all", label: "All" },
      ...(this.state.locationData
        ? this.state.locationData.map(item => ({
          value: item.rec_id,
          label: item.location_name,
        }))
        : []),
    ];

    return (
      <>
        <SwOffCanvas
          show={this.state.showFilterOffCanvas}
          onClose={this.handleCloseFilter}
          title="Seat Filters"
          footer={
            <div className="OffCanvasFooter_Btns">
              <SwButton
                variant="dark-outline"
                type="button"
                onClick={() => {
                  this.handleCloseFilter();
                  this.reload();
                }}
                className="ml10"
              >
                Reload
              </SwButton>
              <SwButton
                variant="primary"
                className="ml10"
                onClick={this.submitFilter}
              >
                Apply
              </SwButton>
            </div>
          }
        >

          <div className="SwFormGroup">
            <label className='SwFormLabel'>Location</label>
            <SwSelect
              id='MSFLocation'
              className="formAddmemGrid"
              name="location"
              options={locationOptions}
              placeholder="Select Location"
              isClearable={false}
              value={locationOptions.find(
                opt => opt.value === this.state.location
              )}
              onChange={(selectedOption) => {
                this.changeSelect({
                  target: {
                    name: "location",
                    value: selectedOption ? selectedOption.value : "all",
                  },
                });
              }}
            />
          </div>


          <div className="SwFormGroup">
            <label className='SwFormLabel'>Seat Type</label>
            <SwSelect
              id='MSFSeatType'
              onChange={this.SeatTypemethod}
              options={seatType}
              placeholder='Select Seat type'
              isClearable={false}
            />

          </div>

          <div className="SwFormGroup">
            <label className='SwFormLabel'>Seat Status</label>
            <SwSelect
              id='MSFSeatStatus'
              onChange={this.SeatStatusmethod}
              options={seatStatus}
              placeholder='Select Seat Status'
              isClearable={false}
            />

          </div>

          <div className="SwFormGroup">
            <label className='SwFormLabel'>Seat No.</label>
            <SwSelect
              id='SBFSeatNo'
              value={this.state.refreshSeat}
              onChange={this.handleChange}
              options={seatNumbers}
              placeholder='Select Seat no.'
              isClearable={false}
            />
          </div>


          <div className="SwFormGroup">
            <label className='SwFormLabel'>Employee Name</label>
            <SwSelect
              id='SBFEmployeeName'
              onChange={this.handleChange1}
              options={empNames}
              value={this.state.refreshemp}
              isClearable={false}
            />
          </div>


        </SwOffCanvas>

        <SwIconButton size='sm' onClick={this.handleOpenFilter}>
          <i className="bi bi-funnel" />
        </SwIconButton>
      </>
    );
  }
}

const mapStateToProps = state => {

  return {
    seatReducer: state.seatReducer.SeatList,
    LocationList: state.seatReducer.LocationFilterList,
    seatName: state.seatReducer.SeatMapData,
    location: state.locationReducer.SeatList,
  };
};

const mapActionsToProps = {
  SeatData,
  SelectLocation,
  LocationFilterAction,
  SeatMappingName,
  CheckLoader,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(FilterSeat);
